import { Component, Input, OnInit } from '@angular/core';
import { Meta } from '@angular/platform-browser';
import { Menu } from '../../../menu/models/menu.model';

@Component({
    selector: 'app-menu-images',
    templateUrl: './menu-images.component.html',
    styleUrls: ['./menu-images.component.scss'],
    standalone: false
})
export class MenuImagesComponent implements OnInit {
  /**
   * Informacion del menu seleccionado
   */
  @Input() menu: Menu = {} as Menu;
  constructor(
    private meta: Meta
  ) { }

  ngOnInit(): void {
    this.meta.updateTag({ name: 'viewport', content: 'width=device-width, initial-scale=1, maximum-scale=4, user-scalable=yes' });
  }

}
